import React from 'react'
import { PageHeader, ListGroup, ListGroupItem } from 'react-bootstrap'

function PopupBlockPage() {
  return (
    <div>
      <PageHeader>Pop-up bloqueada? Siga as instruções de acordo com o navegador utilizado:</PageHeader>

      <h3>Google Chrome</h3>
      <ListGroup>
        <ListGroupItem>Na barra de endereço, clique em <strong>Pop-up bloqueado</strong> <img alt="" src="/chrome-popup-block.png" /></ListGroupItem>
        <ListGroupItem>Marque a opção <strong>Sempre permitir pop-ups do...</strong> e confirme.</ListGroupItem>
        <ListGroupItem><strong>Pronto!</strong> Agora é só tentar novamente.</ListGroupItem>
      </ListGroup>

      <h3>Firefox</h3>
      <ListGroup>
        <ListGroupItem>Uma barra amarela no topo da página aparecerá informando que o Firefox impediu que este site abrisse uma janela pop-up. <img alt="" src="/firefox-popup-block.png" /></ListGroupItem>
        <ListGroupItem>Clique no botão ao lado direito desta mesma janela <strong>Preferências</strong> <img alt="" src="/firefox-popup-block-prefs.png" />.</ListGroupItem>
        <ListGroupItem>Em seguida, clique na opção <strong>Permitir pop-ups para este site</strong>.</ListGroupItem>
        <ListGroupItem><strong>Pronto!</strong> Agora é só tentar novamente.</ListGroupItem>
      </ListGroup>
    </div>
  )
}

export default PopupBlockPage
